export default __webpack_public_path__ + "static/media/baby23.92f6ef38.gif";